import React from 'react';
import './BlockTypeSelector.css';

const BlockTypeSelector = ({ onSelect, onClose }) => {
    const blockTypes = [
        {
            type: 'email',
            title: 'Send Email',
            description: 'Send an email to a recipient',
            icon: '📧',
            color: '#007bff'
        },
        {
            type: 'delay',
            title: 'Delay',
            description: 'Wait for a specified amount of time',
            icon: '⏰',
            color: '#ffc107'
        }
    ];

    return (
        <div className="block-selector-overlay" onClick={onClose}>
            <div className="block-selector-modal" onClick={(e) => e.stopPropagation()}>
                <div className="block-selector-header">
                    <h3>Add Step</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                <div className="block-selector-content">
                    {blockTypes.map((blockType) => (
                        <div 
                            key={blockType.type}
                            className="block-type-option"
                            onClick={() => onSelect(blockType.type)}
                        >
                            <div 
                                className="block-type-icon"
                                style={{ backgroundColor: blockType.color }}
                            >
                                {blockType.icon}
                            </div>
                            <div className="block-type-info">
                                <div className="block-type-title">{blockType.title}</div>
                                <div className="block-type-description">{blockType.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlockTypeSelector; 